(function () {

  'use strict';

  function focusMe() {
    return {
      scope: { trigger: '=focusMe' },
      link: function(scope, element) {


      var unregister = scope.$watch('trigger', function (value) {
        if(value === true) { 
          element[0].focus();
          scope.trigger = false;
          unregister();
        }
      });

    }
  };
}

  focusMe.$inject = [];

  angular
    .module('printix-admin')
    .directive('focusMe', focusMe);

})();